// Load jQuery easing plugin from vendor
import easing from '@vendor/javascripts/jquery.easing';

easing(jQuery);
